import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import Preferences from "./Preferences";
import Integrations from "./Integrations";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
export default function ProfileSetting() {
  const captureEvent = useCaptureEvent();
  return (
    <Tabs defaultValue="preferences" className="w-full">
      <TabsList className="my-3 flex w-full justify-center items-center h-min p-1 rounded-[8px] overflow-hidden border border-border bg-gray-50">
        <TabsTrigger
          className="flex-1 rounded-md px-3 py-2.5 text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-gray-700 data-[state=active]:shadow"
          value="preferences"
          onClick={() => {
            captureEvent("EXU_Preferences_SettingsBtn");
          }}
        >
          Settings
        </TabsTrigger>
        <TabsTrigger
          className="flex-1 rounded-md px-3 py-2.5 text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-gray-700 data-[state=active]:shadow"
          value="integrations"
          onClick={() => {
            captureEvent("EXU_Preferences_IntegrationsBtn");
          }}
        >
          Integrations
        </TabsTrigger>
      </TabsList>
      <TabsContent value="preferences">
        <div className="pt-1">
          <Preferences />
        </div>
      </TabsContent>
      <TabsContent value="integrations">
        <div className="pt-1">
          <Integrations />
        </div>
      </TabsContent>
    </Tabs>
  );
}
